<template>
  <div class="z-toast toast-override">
    <template v-for="(toast, index) in toasts">
      <z-toast
        :key="index"
        :type="toast.type"
        :message="toast.message"
        :timeout="toast.timeout"
        @close="hide(index)"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.toast-override {
  bottom: 24px;
  top: auto;
  z-index: 2;

  @media (min-width: $screen-md-min) {
    bottom: auto;
    left: auto;
    max-width: 600px;
    top: 24px;
  }
}
</style>

<script>
import ZToast from 'components/zilla/z-toast';

export default {
  created() {
    this.$toast.setContainer(this);
  },
  data() {
    return {
      toasts: [],
    };
  },
  methods: {
    show(type, message, timeout) {
      this.toasts.push({ type, message, timeout });
    },
    hide(index) {
      this.toasts.splice(index, 1);
    },
  },
  components: {
    ZToast,
  },
};
</script>
